/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';

import type { CloseWorkOrdersCommand } from '../models/CloseWorkOrdersCommand';
import type { RollBackWorkOrdersCommand } from '../models/RollBackWorkOrdersCommand';
import type { UpdateWorkOrderSupervisorCommand } from '../models/UpdateWorkOrderSupervisorCommand';
import type { UploadClientsCommand } from '../models/UploadClientsCommand';
import type { UploadEmployeesCommand } from '../models/UploadEmployeesCommand';
import type { UploadWorkOrdersCommand } from '../models/UploadWorkOrdersCommand';

import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

@Injectable({
  providedIn: 'root',
})
export class SyncService {

    constructor(public readonly http: HttpClient) {}

    /**
     * @param version 
     * @param requestBody 
     * @returns any Success
     * @throws ApiError
     */
    public postVSyncUploadClients(
version: string,
requestBody?: UploadClientsCommand,
): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/v{version}/Sync/uploadClients',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns any Success
     * @throws ApiError
     */
    public postVSyncUploadEmployees(
version: string,
requestBody?: UploadEmployeesCommand,
): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/v{version}/Sync/uploadEmployees',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns any Success
     * @throws ApiError
     */
    public postVSyncUploadWorkOrders(
version: string,
requestBody?: UploadWorkOrdersCommand,
): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/v{version}/Sync/uploadWorkOrders',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns any Success
     * @throws ApiError
     */
    public putVSyncUpdateWorkOrderSupervisor(
version: string,
requestBody?: UpdateWorkOrderSupervisorCommand,
): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/v{version}/Sync/updateWorkOrderSupervisor',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns any Success
     * @throws ApiError
     */
    public putVSyncRollBackWorkOrder(
version: string,
requestBody?: RollBackWorkOrdersCommand,
): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/v{version}/Sync/rollBackWorkOrder',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param validatedDate 
     * @returns any Success
     * @throws ApiError
     */
    public getVSyncGetValidatedWorkOrders(
version: string,
validatedDate?: string,
): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/v{version}/Sync/getValidatedWorkOrders',
            path: {
                'version': version,
            },
            query: {
                'validatedDate': validatedDate,
            },
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns any Success
     * @throws ApiError
     */
    public putVSyncCloseWorkOrders(
version: string,
requestBody?: CloseWorkOrdersCommand,
): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/v{version}/Sync/closeWorkOrders',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
